import { DefaultButton, PrimaryButton } from "@fluentui/react";
import React, { useContext } from "react";
import "./styles/ModalFooterCss.css";
import themeContext from "../../context/theme/ThemeContext";

const QCModalFooter = (props) => {
  const { getThemeColor,getAlterColor } = useContext(themeContext);
  return (
    <>
      <div
        style={{
          background:  getThemeColor("modal-header-footer"),
          height:"50px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          padding:"0px",
          borderRadius: "0px 0px 10px 10px"
        }}
      >
        {/* <hr style={{
            border: "1px solid #4D4D4D",
            marginTop: "0px",
            marginBottom: "14px",
            width: "99%"
        }}/> */}
        <div style={{
            justifyContent:"flex-end",
            alignItems: "center",
            display: "flex",
            // paddingBottom: "13px"
        }}>
          {props.DefaultButtonList &&
            props.DefaultButtonList.map((obj, index) => (
              <DefaultButton
                key={index}
                text={obj.title}
                style={{
                  marginRight: "15px",
                }}
                onClick={obj.onclick}
              />
            ))}
          {props.PrimaryButtonList &&
            props.PrimaryButtonList.map((obj, index) => (
              <PrimaryButton
                key={index}
                text={obj.title}
                style={{
                  marginRight: "24px",
                }}
                onClick={obj.onclick}
                disabled={obj.disable != null && obj.disable != undefined ? obj.disable : false}
              />
            ))}
        </div>
      </div>
    </>
  );
};

export default QCModalFooter;
